import { cn } from '@/lib/utils'

export default function PageWrapper({
  children,
  className,
  hasBottomBar = false,
  ...props
}) {
  return (
    <main
      className={cn(
        `
          relative min-h-0 flex-1 overflow-y-auto rounded-lg border border-light
          bg-white transition-all duration-300 ease-out
        `,
        // Hide scrollbar
        '[&::-webkit-scrollbar]:hidden',
        '[-ms-overflow-style:none]',
        '[scrollbar-width:none]',
        !hasBottomBar && 'rounded-b-none',
        className,
      )}
      {...props}
    >
      {children}
    </main>
  )
}
